import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		settings: {
			citizenship: [],
			educationTypes: [],
			czNaces: [],
			czIscos: [],
			scanTypes: [
				{
					key: 'passport',
					value: 'Passport'
				}
			],
			tituls1: [],
			tituls2: [],
			insuranceCompanies: []
		},
		countries: []
	},
	getters: {
		getCitizenship({ settings, countries }) {
			const list = settings.citizenship
				.reduce((acc, item) => {
					const country = countries.find(({ code }) => {
						return (item.code || item) === code
					})
					acc.push(country)
					return acc
				}, [])
			return list
		},
		educationTypesKey({ settings }) {
			return settings.educationTypes.map(({ key }) => key)
		},
		educationTypesKeyValue({ settings }) {
			return settings.educationTypes
		},
		tituls1({ settings }) {
			return settings.tituls1.map(({ value }) => value)
		},
		tituls2({ settings }) {
			return settings.tituls2.map(({ value }) => value)
		},
		czIscos({ settings }) {
			return settings.czIscos
		},
		czNaces({ settings }) {
			return settings.czNaces
		},
		scanTypes({ settings }) {
			return settings.scanTypes
		},
		insuranceCompanies({ settings }) {
			return settings.insuranceCompanies
		}
	},
	actions: {
		async fetch({ commit }) {
			var response = await Vue.http.get('settings')
			commit('setSettings', response.body)
		},
		async changeSetting({ dispatch }, data) {
			await Vue.http.post('settings', data)
			dispatch('fetch')
		},
		async countryList({ commit }) {
			var response = await Vue.http.get('countries')
			commit('setCountries', response.body)
		}
	},
	mutations: {
		setSettings(state, setting) {
			state.settings = { ...state.settings, ...setting }
		},
		setCountries(state, countries) {
			state.countries = Object.keys(countries).map(function(key, index) {
				return {
					code: key,
					name: countries[key]
				}
			})
		},

		addEduType({ settings }, { key, value, id }) {
			settings.educationTypes = [...settings.educationTypes, { key, value, id }]
		},
		changeEduType({ settings }, type) {
			settings.educationTypes = settings.educationTypes.map(
				item => (item.id === type.id ? type : item)
			)
		},
		removeEduType({ settings }, id) {
			settings.educationTypes = settings.educationTypes.filter(
				item => item.id !== id
			)
		},

		addCzIsco({ settings }, { key, value, id }) {
			settings.czIscos = [...settings.czIscos, { key, value, id }]
		},
		changeCzIsco({ settings }, type) {
			settings.czIscos = settings.czIscos.map(
				item => (item.id === type.id ? type : item)
			)
		},
		removeCzIsco({ settings }, id) {
			settings.czIscos = settings.czIscos.filter(item => item.id !== id)
		},

		addCzNace({ settings }, { key, value, id }) {
			settings.czNaces = [...settings.czNaces, { key, value, id }]
		},
		changeCzNace({ settings }, type) {
			settings.czNaces = settings.czNaces.map(
				item => (item.id === type.id ? type : item)
			)
		},
		removeCzNace({ settings }, id) {
			settings.czNaces = settings.czNaces.filter(item => {
				return item.id !== id
			})
		},

		addScanType({ settings }, { key, value, id }) {
			settings.scanTypes = [...settings.scanTypes, { key, value, id }]
		},
		changeScanType({ settings }, type) {
			settings.scanTypes = settings.scanTypes.map(
				item => (item.id === type.id ? type : item)
			)
		},
		removeScanType({ settings }, id) {
			settings.scanTypes = settings.scanTypes.filter(item => item.id !== id)
		},

		addTitul1({ settings }, { value, id }) {
			settings.tituls1 = [...settings.tituls1, { value, id }]
		},
		changeTitul1({ settings }, type) {
			settings.tituls1 = settings.tituls1.map(
				item => (item.id === type.id ? type : item)
			)
		},
		removeTitul1({ settings }, id) {
			settings.tituls1 = settings.tituls1.filter(item => item.id !== id)
		},

		addTitul2({ settings }, { value, id }) {
			settings.tituls2 = [...settings.tituls2, { value, id }]
		},
		changeTitul2({ settings }, type) {
			settings.tituls2 = settings.tituls2.map(
				item => (item.id === type.id ? type : item)
			)
		},
		removeTitul2({ settings }, id) {
			settings.tituls2 = settings.tituls2.filter(item => item.id !== id)
		},

		addInsuranceCompany({ settings }, { key, value, id }) {
			settings.insuranceCompanies = [...settings.insuranceCompanies, { key, value, id }]
		},
		changeInsuranceCompany({ settings }, type) {
			settings.insuranceCompanies = settings.insuranceCompanies.map(
				item => (item.id === type.id ? type : item)
			)
		},
		removeInsuranceCompany({ settings }, id) {
			settings.insuranceCompanies = settings.insuranceCompanies.filter(
				item => item.id !== id
			)
		}
	}
}
